import { createContext, ReactNode, useState } from 'react';

interface SidebarCollapseProviderProps {
  children: ReactNode;
}

type SidebarCollapseContextType = {
  isCollapsed: boolean;
  toggleCollapse: () => void;
};

export const SidebarCollapseContext = createContext(
  {} as SidebarCollapseContextType
);

export const SidebarCollapseContextProvider = ({
  children,
}: SidebarCollapseProviderProps) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <SidebarCollapseContext.Provider value={{ isCollapsed, toggleCollapse }}>
      {children}
    </SidebarCollapseContext.Provider>
  );
};
